module.exports = __webpack_public_path__ + "static/media/undraw_Taken_if77.51a1baa0.svg";